import EnvironmentTypes = Infospeed.FrontEnd.COT.EnvironmentTypes;

import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonNotificationService } from '../services/common-notification.service';
import { CustomerName } from '../services/common-utility.service';
import { Observable } from 'rxjs';

@Injectable()
export class CotHttp {
    urlList: UrlDataObject = <UrlDataObject>{};
    environment: EnvironmentTypes = null;
    customer: CustomerName = null;

    constructor(private http: HttpClient, private commonNotificationService: CommonNotificationService) {
    }

    /* passing 2nd parameter as false will not rigger the loading spinner */
    get = (url: string, triggerLoadingSpinner: boolean = true, headers?: HttpHeaders): Observable<any> => {
        if (triggerLoadingSpinner) {
            this.commonNotificationService.emitLoadingSpinner(true);
        }
        if (headers) {
            return this.http.get(url, { headers: headers });
        }
        else {
            return this.http.get(url);
        }
    }

    post = (url: string, data: {}, triggerLoadingSpinner: boolean = true): Observable<any> => {
        if (triggerLoadingSpinner) {
            this.commonNotificationService.emitLoadingSpinner(true);
        }
        return this.http.post(url, data);
    }

    delete = (url: string, triggerLoadingSpinner: boolean = true): Observable<any> => {
        if (triggerLoadingSpinner) {
            this.commonNotificationService.emitLoadingSpinner(true);
        }
        return this.http.delete(url);
    }

    private setConfigUrls(data: any, cust: string) {
        switch (this.environment) {
            case EnvironmentTypes.dev:
                this.urlList.RootUrl = data[cust]['devUrl'];
                break;
            case EnvironmentTypes.uat:
                this.urlList.RootUrl = data[cust]['uatUrl'];
                break;
            case EnvironmentTypes.prod:
                this.urlList.RootUrl = data[cust]['prodUrl'];
                break;
        }
        this.urlList.FlywireScriptLink = data[cust]['FlywireScriptLink'];
        this.urlList.FlywireEnvironment = data[cust]['FlywireEnvironment'];
        this.urlList.FlywireDestination = data[cust]['FlywireDestination'];
        this.urlList.FlywireCallbackUrl = data[cust]['FlywireCallbackUrl'];
        this.urlList.FacebookLink = data[cust]['FacebookLink'];
        this.urlList.FacebookLink2 = data[cust]['FacebookLink2'];
        this.urlList.TwitterLink = data[cust]['TwitterLink'];
        this.urlList.YoutubeLink = data[cust]['YoutubeLink'];
        this.urlList.LinkedinLink = data[cust]['LinkedinLink'];
        this.urlList.InstagramLink = data[cust]['InstagramLink'];
        this.urlList.TransferInformationLink = data[cust]['TransferInformationLink'];
        this.urlList.TermsAndConditionsLink = data[cust]['TermsAndConditionsLink'];
        this.urlList.TermsAndConditionsTeenagerHomestayLink = data[cust]['TermsAndConditionsTeenagerHomestayLink'];
        this.urlList.TermsAndConditionsTeenagerResidentialLink = data[cust]['TermsAndConditionsTeenagerResidentialLink'];
        this.urlList.MedicalInfomationLink = data[cust]['MedicalInformationLink'];
        this.urlList.GooglePlusLink = data[cust]['GooglePlusLink'];
        this.urlList.PinterestLink = data[cust]['PinterestLink'];
        this.urlList.LogUrl = data[cust]['LogUrl'];
        this.urlList.FlywireDestinations = data[cust]['FlywireDestinations'];
    }

    getConfiguredUrl = (urlType: UrlDataEnum): any => {
        switch (urlType) {
            case UrlDataEnum.RootUrl:
                return this.urlList.RootUrl;
            case UrlDataEnum.FacebookLink:
                return this.urlList.FacebookLink;
            case UrlDataEnum.FlywireScriptLink:
                return this.urlList.FlywireScriptLink;
            case UrlDataEnum.TwitterLink:
                return this.urlList.TwitterLink;
            case UrlDataEnum.YoutubeLink:
                return this.urlList.YoutubeLink;
            case UrlDataEnum.TermsAndConditionsLink:
                return this.urlList.TermsAndConditionsLink;
            case UrlDataEnum.TransferInformationLink:
                return this.urlList.TransferInformationLink;
            case UrlDataEnum.InstagramLink:
                return this.urlList.InstagramLink;
            case UrlDataEnum.LinkedinLink:
                return this.urlList.LinkedinLink;
            case UrlDataEnum.FlywireEnvironment:
                return this.urlList.FlywireEnvironment;
            case UrlDataEnum.FlywireDestination:
                return this.urlList.FlywireDestination;
            case UrlDataEnum.TermsAndConditionsTeenagerHomestayLink:
                return this.urlList.TermsAndConditionsTeenagerHomestayLink;
            case UrlDataEnum.TermsAndConditionsTeenagerResidentialLink:
                return this.urlList.TermsAndConditionsTeenagerResidentialLink;
            case UrlDataEnum.MedicalInformationLink:
                return this.urlList.MedicalInfomationLink;
            case UrlDataEnum.GooglePlusLink:
                return this.urlList.GooglePlusLink;
            case UrlDataEnum.FlywireCallbackUrl:
                return this.urlList.FlywireCallbackUrl;
            case UrlDataEnum.FacebookLink2:
                return this.urlList.FacebookLink2;
            case UrlDataEnum.PinterestLink:
                return this.urlList.PinterestLink;
            case UrlDataEnum.LogUrl:
                return this.urlList.LogUrl;
            case UrlDataEnum.FlywireDestinations:
                return this.urlList.FlywireDestinations;
        }
    }

    setEnvironment(env: EnvironmentTypes, customer: CustomerName): Promise<any> { // called during app_initialization
        this.environment = env;
        this.customer = customer;
        let httpHeaders = new HttpHeaders({ 'Cache-Control': 'no-cache' });
        return new Promise<any>((resolve, reject) => {
            this.get(location.href.split('#')[0] + 'config/config.json', true, httpHeaders).subscribe(
                (data) => {
                    switch (this.customer) {
                        case CustomerName.STONY_HURST:
                            this.setConfigUrls(data, 'stony');
                            break;
                        case CustomerName.BISHOPSTROW:
                            this.setConfigUrls(data, 'bishop');
                            break;
                        case CustomerName.UKCE:
                            this.setConfigUrls(data, 'ukce');
                            break;
                        case CustomerName.ETC:
                            this.setConfigUrls(data, 'etc');
                            break;
                        case CustomerName.CESC:
                            this.setConfigUrls(data, 'cesc');
                            break;
                        case CustomerName.CES_UK:
                            this.setConfigUrls(data, 'cesUk');
                            break;
                        case CustomerName.CES_IRELAND:
                            this.setConfigUrls(data, 'cesIreland');
                            break;
                        case CustomerName.CES_NORTH_AMERICA:
                            this.setConfigUrls(data, 'cesNorthAmerica');
                            break;
                        case CustomerName.ISLINGTON:
                            this.setConfigUrls(data, 'islington');
                            break;
                        case CustomerName.DEVON:
                            this.setConfigUrls(data, 'devon');
                            break;
                        case CustomerName.CHAMBER:
                            this.setConfigUrls(data, 'chamber');
                            break;
                        case CustomerName.MALACA:
                            this.setConfigUrls(data, 'malaca');
                            break;
                        case CustomerName.EUROCENTRES:
                            this.setConfigUrls(data, 'eurocentres');
                            break;
                        case CustomerName.CORK:
                            this.setConfigUrls(data, 'cork');
                            break;
                        case CustomerName.ELC:
                            this.setConfigUrls(data, 'elc');
                            break;
                        case CustomerName.STUDIO_CAMBRIDGE:
                            this.setConfigUrls(data, 'studioCambridge');
                            break;
                        case CustomerName.HARROW_SCHOOL:
                            this.setConfigUrls(data, 'harrow');
                            break;
                        case CustomerName.DEFAULT:
                            this.setConfigUrls(data, 'default');
                            break;
                    }
                    this.commonNotificationService.emitUrlNotification(); // note: this will not notifiy any emitter, so separated and called during app-module construction.
                    resolve();
                },
                (error) => {
                    console.error('Error reading config file.\n\r' + error);
                    reject();
                });
        });
    }
}

export interface UrlDataObject {
    RootUrl: string;
    FlywireScriptLink: string;
    FacebookLink: string;
    YoutubeLink: string;
    TwitterLink: string;
    LinkedinLink: string;
    TermsAndConditionsLink: string;
    TransferInformationLink: string;
    InstagramLink: string;
    FlywireEnvironment: string;
    FlywireDestination: string;
    TermsAndConditionsTeenagerHomestayLink: string;
    TermsAndConditionsTeenagerResidentialLink: string;
    MedicalInfomationLink: string;
    GooglePlusLink: string;
    FlywireCallbackUrl: string;
    FacebookLink2: string;
    PinterestLink: string;
    LogUrl: string;
    FlywireDestinations: any;
}

export enum UrlDataEnum {
    RootUrl,
    FlywireScriptLink,
    FacebookLink,
    YoutubeLink,
    TwitterLink,
    LinkedinLink,
    TermsAndConditionsLink,
    TransferInformationLink,
    InstagramLink,
    FlywireEnvironment,
    FlywireDestination,
    TermsAndConditionsTeenagerHomestayLink,
    TermsAndConditionsTeenagerResidentialLink,
    MedicalInformationLink,
    GooglePlusLink,
    FlywireCallbackUrl,
    FacebookLink2,
    PinterestLink,
    LogUrl,
    FlywireDestinations,
}



// WEBPACK FOOTER //
// ./src/app/http-communication/cot-http.service.ts